export default "__VITE_ASSET__VgrtdAXs__"